export enum DocumentUploadViewTab {
  MASS_UPLOAD = 'mass-upload',
  SINGLE_UPLOAD = 'single-upload',
}
